import {
  VIRTUAL_SCROLL_GRID_ID,
  VIRTUAL_SCROLL_GRID_SCROLL_DELAY,
  VIRTUAL_SCROLL_GRID_SCROLL_OFFSET,
} from '../constants';

/**
 * Scrolls to the top of the grid element.
 * @param {boolean} isMobile - Whether the device is mobile. Defaults to false.
 * @param {string} gridElementId - The ID of the grid element. Defaults to VIRTUAL_SCROLL_GRID_ID.
 * @param {number} yOffset - The vertical offset to apply when scrolling. Defaults to VIRTUAL_SCROLL_GRID_SCROLL_OFFSET.
 * @param {number} delay - The delay before scrolling in milliseconds. Defaults to VIRTUAL_SCROLL_GRID_SCROLL_DELAY.
 * @returns {void}
 */
export const scrollToTopOfGrid = ({
  isMobile = false,
  gridElementId = VIRTUAL_SCROLL_GRID_ID,
  yOffset = VIRTUAL_SCROLL_GRID_SCROLL_OFFSET,
  delay = VIRTUAL_SCROLL_GRID_SCROLL_DELAY,
}) => {
  if (isMobile) {
    return;
  }

  const gridElement = document.getElementById(gridElementId);
  if (gridElement) {
    const y =
      gridElement.getBoundingClientRect().top + window.scrollY + yOffset;

    // Delay the scroll to allow for any layout changes
    setTimeout(() => {
      window.scrollTo({ top: y, behavior: 'smooth' });
    }, delay);
  }
};
